module.exports = __webpack_public_path__ + "static/img/msg_tab1.5987093f.png";